<!--
    Styles
-->

<style scoped>

    .bulk {
        padding: 16px 20px;
        background: var(--cl-white);
        border-top: 1px solid var(--cl-gray);
        align-items: center;
    }
    .bulk .btn {
        min-width: 140px;
        margin: 0 10px;
    }
    .bulk .txt-link {
        margin-left: 28px;
    }

</style>



<!--
    Template
-->

<template>
    <div class="bulk u-row t14">

        <div class="u-flex u-row">
            <p>現在、<span class="w5">{{ count }}</span> 物件選択中</p>
            <a class="txt-link t-line cl-blue" @click="$emit('cancel')">選択をキャンセル</a>
        </div>

        <a class="btn primary" @click="$emit('add')" v-show="vacant">
            <icon-report />
            <span>レポートに追加する</span>
        </a>

        <a class="btn basic outline" @click="$emit('delete')">
            <icon-delete />
            <span>削除する</span>
        </a>

    </div>
</template>



<!--
    Scripts
-->

<script>

    import {mapGetters} from 'vuex';
    import iconDelete from '@/assets/icons/garbage.svg';
    import iconReport from '@/assets/icons/document.svg';

    export default {

        components: {
            iconDelete,
            iconReport
        },

        props: [
            'count'
        ],

        computed: {

            ...mapGetters('search', ['selectedDeals']),

            vacant () {
                return this.selectedDeals.length + this.count <= 5;
            }

        }

    }

</script>
